import {
  Route,
  Switch,
} from 'react-router-dom';
import { useMemo } from 'react';

import * as path from '@urls';
import { productDetails } from '@legacyUrls';
import { useLoadableWithBot } from '@utils/loadable';
import { CatalogPageSkeleton } from '@outlet/pages/CatalogPage/CatalogPageSkeleton';

const useRoutes = () => {
  const loadable = useLoadableWithBot();

  return useMemo(
    () => ({
      NotFoundPage: loadable(() => import('@outlet/pages/NotFoundPage'), { ssr: false }),
      MainPage: loadable(() => import('@outlet/pages/MainPage'), {
        fallback: <CatalogPageSkeleton />,
        ssr: false,
      }),
      CatalogPage: loadable(() => import('@outlet/pages/CatalogPage'), {
        fallback: <CatalogPageSkeleton />,
        ssr: false,
      }),
      AuthRoutes: loadable(() => import('./auth'), { ssr: false }),
      ProductDetailsPage: loadable(() => import('@outlet/pages/ProductDetailsPage'), { ssr: false }),
      ProductReviewsPage: loadable(() => import('@outlet/pages/ProductReviewsPage'), { ssr: false }),
      MainSettingsPage: loadable(() => import('@outlet/pages/MainSettingsPage'), { ssr: false }),
      PhoneVerificationPage: loadable(() => import('@outlet/pages/PhoneVerificationPage')),
      CheckoutPage: loadable(() => import('@outlet/pages/CheckoutPage'), { ssr: false }),
      CheckoutPaymentPage: loadable(() => import('@outlet/pages/CheckoutPaymentPage'), { ssr: false }),
      CheckoutPaymentStatusPage: loadable(() => import('@outlet/pages/CheckoutPaymentStatusPage'), { ssr: false }),
      SecondaryPage: loadable(() => import('@outlet/pages/SecondaryPage'), { ssr: false }),
      NewDialogThanksPage: loadable(() => import('@outlet/pages/NewDialogThanksPage')),
    }),
    [loadable],
  );
};

const Routes: React.FC = () => {
  const routes = useRoutes();

  return (
    <>
      <Switch>
        <Route
          path='/'
          exact={true}
          component={routes.MainPage}
        />

        <Route
          path={path.login}
          component={routes.AuthRoutes}
        />

        <Route
          path={productDetails}
          exact={true}
          component={routes.ProductDetailsPage}
        />

        <Route
          path={path.productReviews}
          exact={true}
          component={routes.ProductReviewsPage}
        />

        <Route
          path={path.baseCatalog}
          component={routes.CatalogPage}
        />

        <Route
          path={path.memberProfile}
          exact={true}
          component={routes.MainSettingsPage}
        />

        <Route
          exact={true}
          path={path.phoneVerification}
          component={routes.PhoneVerificationPage}
        />

        {/* Checkout */}
          <Route
            exact={true}
            path={path.checkoutBuyer}
            component={routes.CheckoutPage}
          />
          <Route
            exact={true}
            path={path.checkoutPayment}
            component={routes.CheckoutPaymentPage}
          />

          <Route
            exact={true}
            path={path.checkoutPaymentAnotherCard}
            component={() => <routes.CheckoutPaymentPage withCardFormOnly={true} />}
          />

          <Route
            exact={true}
            path={path.checkoutPaymentStatus}
            component={routes.CheckoutPaymentStatusPage}
          />

          <Route
            path={path.secondaryPage}
            component={routes.SecondaryPage}
          />

          <Route
            path={path.dialogThanks}
            component={routes.NewDialogThanksPage}
          />

        <Route component={routes.NotFoundPage} />
      </Switch>
    </>
  );
};

export default Routes;
